<template>
    <div class="mx-auto text-center pt-12 w-full">
        <h1 class="h1 mb-4">Notifications</h1>
        <p class="text-xl text-gray-400">How do you want to be notified?</p>
        <p class="text-sm text-gray-400 sm:mb-4 mt-2 mb-4">(Select all that apply)</p>
        <form method="post" :action="route('notifications.store')" class="justify-center">
            <input type="hidden" name="_token" :value="csrf_token" />
            <div class="mx-auto flex justify-center">
                <div class="flex flex-wrap max-w-4xl font-semibold justify-center w-full">

                    <div v-for="notification in notifications" class="sm:w-1/2 md:w-1/3 w-full p-4">
                        <input type="checkbox" name="notifications[]" class="hidden" :value="notification.id"
                            v-model="selected[notification.id]" />
                        <label :value="notification.id" @click="selected[notification.id] = !selected[notification.id]"
                            class="w-full px-8 select-none cursor-pointer flex items-center justify-center h-16 border"
                            :class="selected[notification.id] ? 'border-gray-50 text-gray-50 hover:text-gray-50 hover:border-gray-50 bg-blue-900' : 'border-gray-400 text-gray-400 hover:text-gray-50 hover:border-gray-50'">{{ notification.name }}</label>
                    </div>
                </div>
            </div>
            <div class="flex flex-wrap mt-8 sm:max-w-sm mx-auto">
                <button class="fw-btn fw-btn-green w-full" type="submit" style="outline: none;">Finish
                </button>
            </div>
        </form>
    </div>
</template>
<script>
    export default {
        props: {
            notifications: {
                required: true,
                type: Array
            }
        },
        data() {
            return {
                selected: {},
                csrf_token: window.CSRF
            }
        }
    }

</script>
